import * as React from 'react';
import { IContentProps } from "../../models/content-props";

export interface ISuggestionProps {
    searchSuggestionText: string;
    suggestion: string;
    loading: boolean;

    onSuggestionClick: () => void;
}

export class SearchSuggestion extends React.Component<ISuggestionProps, any> {

    render() {
        if (!this.props.suggestion || this.props.suggestion.length < 1 || this.props.loading) {
            return null;
        }

        return (
            <span className="light">
                {this.props.searchSuggestionText} <a href="#" onClick={this.props.onSuggestionClick}><u>{this.props.suggestion}</u></a>?
            </span>
        );
    }
}